import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Pitches from "../components/Pitches";
import * as adminActions from "./../../../../../actions/admin.actions";
import * as commonActions from "./../../../../../actions/common.actions";

const subHeader = memberId => ({
  items: [
    {
      caption: "Profile",
      url: `/admin/member/approved/${memberId}/profile`
    },
    {
      caption: "Matches",
      url: `/admin/member/approved/${memberId}/matches`
    },
    {
      caption: "Pitches",
      url: `/admin/member/approved/${memberId}/pitches`
    },
    {
      caption: "SOWs",
      url: `/admin/member/approved/${memberId}/sows`
    }
  ],

  activeItem: 2
});

class AdminMemberPitchesContainer extends Component {
  constructor(props) {
    super(props);

    props.adminActions.getUser(this.props.match.params.memberId);
  }

  componentDidMount() {
    this.props.commonActions.setSubHeader(
      subHeader(this.props.match.params.memberId)
    );
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
  }

  getPitchedMatches() {
    const { matches } = this.props.admin.user;
    let pitchedMatches = [];

    if (matches) {
      pitchedMatches = _.filter(matches, { pitched: true });
    }

    return pitchedMatches;
  }

  render() {
    return <Pitches pitchedMatches={this.getPitchedMatches()} />;
  }
}

const mapStateToProps = state => {
  return {
    admin: state.admin
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminMemberPitchesContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/memberApprovedProfile/pitches/containers/AdminMemberPitchesContainer.js